import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

export default class HashtagDelete extends Component {
    constructor(props) {
        super(props);

        this.state = {
            model: null,
            loading: false
        }

        this.hashtagDelete = this.hashtagDelete.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            model : props.model
        })
    }

    hashtagDelete() {
        this.setState({
            loading: true
        });

        axios.post(global.config.apiDomain + '/rest/hashtag/delete', this.state.model)
        .then(res => {
            this.setState({
                loading: false
            });

            if (res.data.status == "OK") {
                window.$("#modalDelete").modal("hide");
                toast.success(res.data.message); 
                this.props.resetList();
            } else {
                toast.warning(res.data.message);
            }
        })
    }

    render() {
        const {model} = this.state;

        return (
            <div>
                <div className="modal fade" id="modalDelete" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            {(model && !model.deleted) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">Ẩn hashtag</h5>
                            ) : ""}
                            {(model && model.deleted) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">Hiện hashtag</h5>
                            ) : ""}
                               
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {(model && !model.deleted) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">Bạn chắc chắn muốn Ẩn hashtag {model._id}?</h3>
                            </div>
                            ) : ""}
                            {(model && model.deleted) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-info">Bạn muốn Hiện hashtag{model._id} ?</h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.hashtagDelete}>Xác nhận</button>    
                                )}                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}